import { questionLabelOption } from '@/api/index2';

export default {
  namespaced: true,
  state: () => ({
    questionLabel: null,
    _pendingPromise: null,
  }),
  mutations: {
    setQuestionLabel(state, value) {
      state.questionLabel = value;
    },
    clearCourseCategory(state) {
      state.questionLabel = null;
    },
  },
  actions: {
    async getQuestionLabel({ commit, state }) {
      if (state.questionLabel) {
        return state.questionLabel;
      }
      if (state._pendingPromise) {
        return state._pendingPromise;
      }
      state._pendingPromise = (async () => {
        try {
          let res = await questionLabelOption();
          if (!res.data || !Array.isArray(res.data)) {
            throw new Error('无效的API响应结构');
          }
          let questionLabel = res.data;
          commit('setQuestionLabel', questionLabel);
          return questionLabel;
        } finally {
          state._pendingPromise = null;
        }
      })();
      return state._pendingPromise;
    },

    async updateQuestionLabel({ commit, dispatch }) {
      try {
        commit('clearQuestionLabel');
        const questionLabel = await dispatch('getQuestionLabel');
        return questionLabel;
      } catch (error) {
        console.error('试题标签刷新失败:', error);
        throw error;
      }
    },
  },
};
